import { requireStates } from "util";
import { ConnectComponent2 } from "util";
import View from "./view";
import Presenter from "./presenter";

const initialStates = [
  {
    name: "app.history.stock_entry_reports",
    url: "/entrada-de-produtos",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        name: "Histórico de Entrada de Produtos",
        priority: 400,
        state: "app.history.stock_entry_reports"
      }
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/history/stock-entry-reports/index.js